import React from 'react';
const styles = {"spinner":"Spinner-module__spinner__lXCt0","trip-os-spin":"Spinner-module__trip-os-spin__A0Qkl"};
/**
 * A spinning ring in the current text colour. With a label it is a status announced to assistive technology;
 * without one it is decorative (for example inside a loading Button, whose label is visible).
 */
export function Spinner({ size = 24, label }) {
    const thickness = size > 20 ? 'thick' : 'thin';
    let accessibility;
    if (label === undefined) {
        accessibility = { 'aria-hidden': 'true' };
    }
    else {
        accessibility = { role: 'status', 'aria-label': label };
    }
    return (React.createElement("span", { className: styles.spinner, "data-size": size, "data-thickness": thickness, ...accessibility }));
}
//# sourceMappingURL=Spinner.js.map